import React, { Component } from 'react';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import ListEditor from './ListEditor.js'

const DEFAULT_REINFORCEMENT_QUESTIONS = [{question: "", answer: "", key: 0}];
class ReinforcementQuestions extends Component {
    render() {
        const hasMoreThanOne = this.props.reinforcementQuestions && this.props.reinforcementQuestions.length > 1;
        return (
            <ListEditor
                values={this.props.reinforcementQuestions}
                defaultValues={DEFAULT_REINFORCEMENT_QUESTIONS}
                valuesMinLength={0}
                valuesMaxLength={2}
                createListItem={(listItemData) =>
                    <ReinforcementQuestion
                        index={listItemData.index}
                        key={listItemData.key}
                        question={listItemData.value.question}
                        answer={listItemData.value.answer}
                        updateListItem={listItemData.updateListItem}
                        hasSiblings={hasMoreThanOne}/>
                }
                setListItems={(listItems) => {
                    // Newly created objects will just be {key}, ensure that we have {question, answer}
                    this.props.setReinforcementQuestions(listItems.map(item => ({
                        question: item.question ?? "",
                        answer: item.answer ?? "",
                    })))
                }}
                validationErrors={this.props.validationErrors}
                addButtonText={"Add reinforcement question"}
            />
        )
    }
}

class ReinforcementQuestion extends Component {
    constructor(props) {
        super(props);
        this.handleQuestionChange = this.handleQuestionChange.bind(this);
        this.handleAnswerChange = this.handleAnswerChange.bind(this);
    }
    handleQuestionChange(e) {
        this.props.updateListItem(this.props.index, {question: e.target.value});
    }
    handleAnswerChange(e) {
        this.props.updateListItem(this.props.index, {answer: e.target.value});
    }
    render() {
        const containerClass = this.props.hasSiblings ? "reinforcement-question-container gradient-border" : "reinforcement-question-container"
        return (
            <div className={containerClass}>
                <FormGroup controlId="question-reinforcement-question">
                    <ControlLabel>Reinforcement question</ControlLabel>
                    <FormControl
                        value={this.props.question}
                        componentClass="textarea"
                        placeholder="One related question without answer choices"
                        onChange={(e) => this.handleQuestionChange(e)}>
                    </FormControl>
                </FormGroup>
                <FormGroup controlId="question-reinforcement-question-answer">
                    <ControlLabel>Reinforcement question answer</ControlLabel>
                    <FormControl
                        value={this.props.answer}
                        componentClass="textarea"
                        placeholder="This can be between a few words and one complete sentence"
                        onChange={(e) => this.handleAnswerChange(e)}>
                    </FormControl>
                </FormGroup>
            </div>
        )
    }
}

export default ReinforcementQuestions;
